import { createFileRoute, redirect, useParams } from '@tanstack/react-router'
import { WorkspaceMembersSettings } from '@/features/workspaces/settings'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members'
)({
  beforeLoad: ({ context, params }) => {
    if (!context.isPrivateWorkspace) {
      throw redirect({
        to: '/org/$orgId/workspace/$workspaceId/settings/general',
        params,
        replace: true,
      })
    }
  },
  component: MembersSettingsPage,
})

function MembersSettingsPage() {
  const { orgId, workspaceId } = useParams({
    from: '/_authenticated/org/$orgId/workspace/$workspaceId/settings/members',
  })

  return <WorkspaceMembersSettings orgId={orgId} workspaceId={workspaceId} />
}
